export function getQueryParam(qparam: string, remove = false) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const res = urlSearchParams.get(qparam);
  if (res && remove) {
    urlSearchParams.delete(qparam);
    const newQueryParams = urlSearchParams.toString() || '';
    const url =
      window.location.href.split('?')[0] +
      (newQueryParams ? '?' : '') +
      newQueryParams;
    window.history.replaceState({}, '', url);
  }
  return res;
}

export function removeQueryParameters(url: string) {
  try {
    const urlObj = new URL(url);
    urlObj.search = '';
    urlObj.hash = '';
    return urlObj.toString();
  } catch (e) {
    return undefined;
  }
}
